/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Charge } from '@r6digital/rapidstor-types/react/entities/Charge';
import { LineItem } from '@r6digital/rapidstor-types/types/Merchandise';
import { CostRetrieveResponse } from '@r6digital/rapidstor-types/types/Reservation';

import HorizontalPricingTable from './PricingTableHorizontal';
import VerticalPricingTable from './PricingTableVertical';

interface Props {
    style?: PricingTableStyle;
    costRetrieve: CostRetrieveResponse | undefined;
    charges: Charge[] | undefined;
    moveIn?: boolean;
    cart?: LineItem[];
    merchandiseDiscount: number;
    showTaxRow?: boolean;
}

export interface CostRetrieveItem {
    chargeAmount: number;
    chargeDescription: string;
    chargePeriod?: string;
    initialChargeAmount: number;
    initialTaxAmount: number;
    initialTotal: number;
    taxAmount: number;
    discountTaxAmount: number;
    discountChargeAmount: number;
    discountName?: string;
    discountAmount: number;
    total: number;
}

export type PricingTableStyle = 'horizontal' | 'vertical';

const usePricingTableVariant = (props: Props) => {
    switch (props.style) {
        case 'vertical':
            return <VerticalPricingTable {...props} />;
        case 'horizontal':
        default:
            return <HorizontalPricingTable {...props} />;
    }
};

export default function WizardPricingTable(props: Props) {
    return usePricingTableVariant(props);
}
